import React from 'react'
import "./Widgets.css";
import {Avatar} from "@material-ui/core"

function Widgets() {
    return (
        <div className="widgets">
            
            <div className="accountInfo ">

            <div className="story__avatar">
                <Avatar src="pro.png"/>
                </div>

                <div className="name">
                <h4>tx5ingh </h4>
                <h4 className="username"> T.A.R.A.N.</h4>
                </div>
                </div>

                <div className="suggestions">

                    <div className="headings">
                    <h3> Suggestions For You</h3>
                    <a href="#">See All</a>
                </div>
                </div>


                <div className="options">

                    <div className="profile">
                        
                        <Avatar/>
                        
                        <div className="two">
                            <h4>Cherry0101</h4>
                            <h4 className="username">Suggested For You</h4>
                            </div>

                            <a href="#">Follow</a>
                        </div>

                        <div className="profile">
                        
                        <Avatar/>
                        
                        <div className="two">
                            <h4>Blossomz</h4>
                            <h4 className="username">Suggested For You</h4>
                            </div>

                            <a href="#">Follow</a>
                        </div>

                        <div className="profile">
                        
                        <Avatar/>
                        
                        <div className="two">
                            <h4>puppieInstagram</h4>
                            <h4 className="username">Suggested For You</h4>
                            </div>

                            <a href="#">Follow</a>
                        </div>

                        <div className="profile">
                        
                        <Avatar/>
                        
                        <div className="two">
                            <h4>Kissan Ekta</h4>
                            <h4 className="username">Suggested For You</h4>
                            </div>

                            <a href="#">Follow</a>
                        </div>

                        <div className="profile">
                        
                        <Avatar/>
                        
                        <div className="two">
                            <h4>InterUnion</h4>
                            <h4 className="username">Suggested For You</h4>
                            </div>

                            <a href="#">Follow</a>
                        </div>

                        <div className="lists">
                            <ul>
                                <li>About</li>
                                <li>Help</li>
                                <li>Press</li>
                                <li>API</li>
                                <li>Privacy</li>
                                <li>Terms</li>
                                <li>Locations</li>
                                <li>Top Accounts</li>
                                <li>Hashtags</li>
                                <li>Language</li>
                                
                                </ul>
                            </div>


                </div>

                
        </div>
    )
}

export default Widgets
